"use strict";

exports.__esModule = true;
exports.PROOF_MODE_CHANGE = exports.PROOF_ITEM_SELECT = exports.PROOF_ITEM_HOVER = exports.TOGGLE_LOVE = void 0;
var TOGGLE_LOVE = 'TOGGLE_LOVE';
exports.TOGGLE_LOVE = TOGGLE_LOVE;
var PROOF_ITEM_HOVER = 'PROOF_ITEM_HOVER';
exports.PROOF_ITEM_HOVER = PROOF_ITEM_HOVER;
var PROOF_ITEM_SELECT = 'PROOF_ITEM_SELECT';
exports.PROOF_ITEM_SELECT = PROOF_ITEM_SELECT;
var PROOF_MODE_CHANGE = 'PROOF_MODE_CHANGE';
exports.PROOF_MODE_CHANGE = PROOF_MODE_CHANGE;